import request from '@/utils/request'
import {VueAxios} from './axios'

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  }
}

/**
 * 导出通用
 * @param {object} data
 */
function exportTableRuqest(url, data) {
  return request({
    url,
    method: 'post',
    responseType: 'blob',
    data,
    headers: {
      'Content-Type': 'application/json; application/octet-stream'
    }
  })
}

export default request

export {
  installer as VueAxios,
  request as axios,
  exportTableRuqest
}
